export class ApiConnectionSelectedOptions {
	public database: string;
	public businessUnit: string;
	public sstnLoggingStyle: string;
	public dhlLoggingStyle: string;
}
